import { useTranslation } from "react-i18next";
import { NameSpace, socialMedia } from "../../data/AppLanguage";
import { useEffect, useState } from "react";
import GammaService from "../../services/api/Gamma";
import Util from "../../utils/Util";
import { useAppDispatch } from "../../app/hooks";
import { SolutionModel } from "../../models/SolutionModel";
import ImageGallery from "./ImageGallery";
import { GammaModel } from "../../models/GammaModel";


interface Props {   
    path: string;  
    className?: string;
}


const ImageGalleries = (props: Props) => {
    const [gammas, setGammas] = useState<GammaModel[]>([]);

    const defaultItemsPerPage = 12;
    const defaultCurrentPage = 1;
    
  const [currentPage, setCurrentPage] = useState(defaultCurrentPage);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);
  const [filteredItems, setFilteredItems] = useState<SolutionModel[]>([]);
  const [filtered, setFiltered] = useState(false);

  const indexLastItem = currentPage * itemsPerPage;
  const indexFirstItem = indexLastItem - itemsPerPage;
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const paginatedItems = filteredItems.slice(indexFirstItem, indexLastItem);

    const { t, i18n } = useTranslation([
        NameSpace.COMMON,
        NameSpace.GLOSSARY,
        NameSpace.NAVIGATION,
        NameSpace.ROUTES,
    ]);
    

//---------------------------------------------------------------------------
const setPagination = (page: number) => {
    setCurrentPage(page);
  };

  const setFilter = (filter: string) => {   
    setItemsPerPage(defaultItemsPerPage);
  };

    const solutionsPath = t("solutions", { ns: NameSpace.ROUTES });

    const language = Util.splitLanguage(i18n.language, 0);

    useEffect(() => {
        let mounted = true;

        if(mounted){
            GammaService.getGammas(language).then((res) => {
                setGammas(res.data);              
            });
        }      

        return() => {
            mounted = false;

        };
    }, [language]);

return (
    <>
        <div>
            <h4>{t("solutions", { ns: NameSpace.NAVIGATION })}</h4>
            
            <ImageGallery 
              // filter={{ setFilter, types: solutionsTypes }}
               pagination={{
                 totalPages,
                 defaultCurrentPage,
                 currentPage,
                 filtered,
                 setFiltered,
                 setPagination,
                 defaultItemsPerPage,
                 itemsPerPage,
                 setItemsPerPage,
               }}
            gammas={gammas} 
            path={solutionsPath}/>
        </div>
    </>
);
}

export default ImageGalleries;


